import { render } from "./service-list.vue?vue&type=template&id=0fc5d559&lang=html"
import script from "./service-list.vue?vue&type=script&lang=js"
export * from "./service-list.vue?vue&type=script&lang=js"

import "./service-list.vue?vue&type=style&index=0&id=0fc5d559&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__